

//toast
import toast from '@/components/Toast';

//bind_Modal
//大区绑定
import bind_modal from '@/components/AreaBind';

//gacha_detail
//卡池一览
import gacha_detail from '@/components/GachaDetail';

//msg_modal
//消息通知
import msg_modal from '@/components/MsgModal';

//result_modal
//抽奖结果
import result_modal from '@/components/ResultModal';

//record_modal
//中奖记录
import record_modal from '@/components/RecordModal';

//web_share
//网页助力
import web_share from '@/components/WebShare';

//web_apply
//助力确认
import web_apply from '@/components/WebApply';

//invite_modal
//回归邀请
import invite_modal from '@/components/InviteModal';

//invite_apply
//邀请确认
import invite_apply from '@/components/InviteApply';

//ali_modal
//支付宝信息
import ali_modal from '@/components/AliModal';

//misc_modal
//主播陪玩
import misc_modal from '@/components/MiscModal';

//welcome_modal
//开屏有礼
import welcome_modal from '@/components/WelcomeModal';

//opt_modal
//红包兑换游戏道具
import opt_modal from '@/components/OptModal';

let utils = {
    $toast: toast,
    $bind_modal : bind_modal,
    $gacha_detail : gacha_detail,
    $msg_modal : msg_modal,
    $result_modal : result_modal,
    $record_modal : record_modal,
    $web_share : web_share,
    $web_apply : web_apply,
    $invite_modal : invite_modal,
    $invite_apply : invite_apply,
    $ali_modal : ali_modal,
    $misc_modal : misc_modal,
    $welcome_modal : welcome_modal,
    $opt_modal : opt_modal,
}

export default utils;